module.exports = __webpack_public_path__ + "img/logo_png8.303f146e.png";